import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {Upload} from "./Upload";
import {InvoiceItem} from "./InvoiceItem";
import {FormatTypes} from "../core/Formater";

export enum InvoiceType {
	ProForm = "proform",
	Regular = "regular",
	Progress = "progress",
	Final = "final"
}

export class Invoice extends BaseModel {
	id: string
	type: InvoiceType
	description: string
	number: string
	deliveryDate: string
	issueDate: string
	dueDate: string
	customerId: string
	contractId: string
	progressInvoiceIds: string
	uploads: Upload[]
	invoiceItems: InvoiceItem[]
	vat: number
	price: number
	netPrice?: number
}

export class InvoiceDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static number: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static type: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
	static deliveryDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED], format: FormatTypes.DATE}
	static issueDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED], format: FormatTypes.DATE}
	static dueDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED], format: FormatTypes.DATE}
	static customerId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static contractId: AttributeDescriptor = {validation: []}
	static progressInvoiceIds: AttributeDescriptor = {validation: []}
	static price: AttributeDescriptor = {validation:[ValidationTypes.REQUIRED], format: FormatTypes.PRICE}
	static vat: AttributeDescriptor = {validation:[], format: FormatTypes.PRICE}
}
